/**
 * Enum for chat widget event names
 */
export enum ChatWidgetEvents {
  ON_NAVIGATE = 'chatwidget:onNavigate',
}

/**
 * Dispatches a custom event to the window object
 * @param eventName - The name of the event from ChatWidgetEvents enum
 * @param detail - The event detail data to pass with the event
 */
export function dispatchEventToWindow<T = unknown>(eventName: ChatWidgetEvents, detail: T): void {
  if (typeof window === 'undefined') {
    return;
  }

  const event = new CustomEvent(eventName, {
    detail,
  });

  window.dispatchEvent(event);
}
